export default "__VITE_ASSET__I9DYohPj__"